import {
  VuexModule,
  Module,
  MutationAction,
  getModule,
  Mutation,
} from "vuex-module-decorators";
import store from "@/store";

import { DataTableOption } from "../../lib/DataTableOption.type";
import { PointSeal } from "~/pointseal.type";
import { SealsDTO } from "~/sealsdto.type";
import { PointSealsService } from "@/services/api/pointseals.service";

@Module({
  dynamic: true,
  store,
  name: "pointseals",
  preserveState: localStorage.getItem("vuex") !== null,
})
export class PointSealsVuexModule extends VuexModule {
  sealsList: PointSeal[] = [];
  sealsListLength: number = 0;
  sealsListLoading: boolean = false;
  sealsListPagination: DataTableOption = new DataTableOption();

  @Mutation setSealsListPagination(value: DataTableOption) {
    if (value != undefined) this.sealsListPagination = value;
    this.sealsListLoading = true;
  }

  @MutationAction
  public async getSealsList(req: SealsDTO) {
    const sealsList = await PointSealsService.getPointSeals(req);
    const sealsListLoading = false;
    const sealsListLength = sealsList.length > 0 ? sealsList[0].row_count : 0;
    return { sealsList, sealsListLength, sealsListLoading };
  }

  @Mutation setNewSealList() {
    this.sealsList = [];
  }
}

export const PointSealsModule = getModule(PointSealsVuexModule);
